import React from 'react';

class SectionHint extends React.PureComponent {
  render() {
    return <p style={{ margin: '10px 0', color: '#666' }} {...this.props} />;
  }
}

export default SectionHint;
